import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../../material.module';

@Component({
  selector: 'app-theme-picker',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './theme-picker.component.html',
  styleUrls: ['./theme-picker.component.css']
})
export class ThemePickerComponent {
  primary = '#cacbd3';
  accent = '#efebec';
  surfaceVariant = '#f5f5f5';
  isDarkMode = false;



  ngOnInit(): void {
    // const saved = localStorage.getItem('user-theme');
    // if (saved) {
    //   const { darkMode, '--primary': primary, '--accent': accent, '--surface-variant': surfaceVariant } = JSON.parse(saved);
    //   this.primary = primary;
    //   this.accent = accent;
    //   this.surfaceVariant = surfaceVariant;
    //   this.isDarkMode = darkMode;
    //   this.applyTheme(false); // apply from saved values without overwriting pickers
    // }
  }

//   applyTheme(save: boolean = true, skipSurface: boolean = false): void {
//   const root = document.documentElement;

//   const primaryColor = this.isDarkMode ? '#121212' : this.primary;
//   const accentColor = this.isDarkMode ? '#dcd8e0ff' : this.accent;
//   const surfaceVariantColor = this.isDarkMode ? '#1e1e1e' : this.surfaceVariant;

//   root.style.setProperty('--primary', primaryColor);
//   root.style.setProperty('--accent', accentColor);
//   root.style.setProperty('--md-sys-color-primary', primaryColor);
//   root.style.setProperty('--md-sys-color-secondary', accentColor);
//   root.style.setProperty('--md-sys-color-tertiary', accentColor);
//   // root.style.setProperty('--md-sys-color-on-primary', '#ffffff');
//   root.style.setProperty('--md-sys-color-on-secondary', '#ffffff');

//   root.style.setProperty('--md-sys-color-surface', this.isDarkMode ? '#121212' : '#ffffff');
//   root.style.setProperty('--md-sys-color-on-surface', this.isDarkMode ? '#ffffff' : '#000000');
//   root.style.setProperty('--md-sys-color-surface-variant', surfaceVariantColor);

//   root.style.setProperty('--mdc-theme-primary', primaryColor);
//   root.style.setProperty('--mdc-theme-secondary', accentColor);

//   document.body.style.backgroundColor = getComputedStyle(root).getPropertyValue('--md-sys-color-surface');
//   document.body.setAttribute('data-theme', this.isDarkMode ? 'dark' : 'light');
//   document.body.classList.toggle('dark-theme', this.isDarkMode);

//   // ✅ Force Angular Material elements to update colors
//   document.querySelectorAll('.mat-mdc-raised-button, .mat-toolbar, .mat-mdc-fab, .mat-mdc-icon-button')
//     .forEach(el => {
//       (el as HTMLElement).style.backgroundColor = '';
//       (el as HTMLElement).style.color = '';
//     });

//   // ✅ Trigger repaint
//   document.body.offsetHeight;

//   if (save) {
//     localStorage.setItem('user-theme', JSON.stringify({
//       darkMode: this.isDarkMode,
//       '--primary': this.primary,
//       '--accent': this.accent,
//       '--surface-variant': this.surfaceVariant
//     }));
//   }

// }
applyTheme(save: boolean = true): void {
  // const root = document.documentElement;

  // const primaryColor = this.isDarkMode ? '#121212' : this.primary;
  // const accentColor = this.isDarkMode ? '#dcd8e0ff' : this.accent;

  // // ✅ Always apply primary/accent
  // root.style.setProperty('--primary', primaryColor);
  // root.style.setProperty('--accent', accentColor);
  // root.style.setProperty('--md-sys-color-primary', primaryColor);
  // root.style.setProperty('--md-sys-color-secondary', accentColor);
  // root.style.setProperty('--md-sys-color-tertiary', accentColor);
  // root.style.setProperty('--md-sys-color-on-secondary', '#ffffff');
  // root.style.setProperty('--mdc-theme-primary', primaryColor);
  // root.style.setProperty('--mdc-theme-secondary', accentColor);

  // ⛔ Surface, surface-variant and the page/body background are now owned by the
  //    global light-blue theme in styles.css (--app-bg, --card-bg, --field-bg,
  //    --surface-soft). Overriding the Material surface vars here forced cards /
  //    fields back to white/grey on every load, so it is intentionally disabled.
  // if (!skipSurfaceForComponent) {
  //   root.style.setProperty('--md-sys-color-surface', this.isDarkMode ? '#121212' : '#ffffff');
  //   root.style.setProperty('--md-sys-color-on-surface', this.isDarkMode ? '#ffffff' : '#000000');
  //   root.style.setProperty('--md-sys-color-surface-variant', surfaceVariantColor);
  //   document.body.style.backgroundColor = getComputedStyle(root).getPropertyValue('--md-sys-color-surface');
  // }

  // ✅ Update body theme class
  // document.body.setAttribute('data-theme', this.isDarkMode ? 'dark' : 'light');
  // document.body.classList.toggle('dark-theme', this.isDarkMode);

  // ❌ Remove forced inline styles to avoid color override
  // document.querySelectorAll('.mat-mdc-raised-button, .mat-toolbar, .mat-mdc-fab, .mat-mdc-icon-button')
  //   .forEach(el => {
  //     (el as HTMLElement).style.backgroundColor = '';
  //     (el as HTMLElement).style.color = '';
  //   });

  // ✅ Trigger repaint
  // document.body.offsetHeight;

  // // ✅ Save to localStorage
  // if (save) {
  //   localStorage.setItem('user-theme', JSON.stringify({
  //     darkMode: this.isDarkMode,
  //     '--primary': this.primary,
  //     '--accent': this.accent,
  //     '--surface-variant': this.surfaceVariant
  //   }));
  // }
}


  onDarkModeToggle(event: any): void {
    this.isDarkMode = event.checked;
    this.applyTheme();
  }

  reset(): void {
    // reset to default light theme
    this.primary = '#cacbd3';
    this.accent = '#efebec';
    this.surfaceVariant = '#f5f5f5';
    this.isDarkMode = false;
    this.applyTheme();
    localStorage.removeItem('user-theme');
  }
}
